import {QuoteWizardNavigationService} from "../../../quoteWizardNavigation.service";
import {ScreenLockService} from "../../../../core/services/screenLockService/screenLock.service";
import {QuoteWizardStateService} from "../../../quoteWizardState.service";

export class QuoteSummaryController{
    public totalPremium: number;
    public propertyPremium: number;
    public generalLiabilityPremium: number;
    public commercialAutoPremium: number;
    public deliveryAutoPremium: number;
    public workersCompPremium: number;
    public umbrellaPremium: number;

    public static $inject = ['quoteWizardNavigationService', 'quoteWizardStateService', 'screenLockService'];

    constructor( private navigationService: QuoteWizardNavigationService,
                 private stateService: QuoteWizardStateService,
                 private screenLockService: ScreenLockService) {

        this.activate();
    }
    private activate(): void {
        this.totalPremium = 0;
        if (this.stateService.viewModel.finishedPolicySummary.packagePolicySummary &&
            this.stateService.viewModel.finishedPolicySummary.packagePolicySummary.policy.include &&
            this.stateService.viewModel.finishedPolicySummary.packagePolicySummary.commercialPropertyLineOfBusiness) {
            this.propertyPremium = this.stateService.viewModel.finishedPolicySummary.packagePolicySummary.commercialPropertyLineOfBusiness.writtenPremium;
            this.totalPremium += this.propertyPremium;
        }
        if (this.stateService.viewModel.finishedPolicySummary.packagePolicySummary &&
            this.stateService.viewModel.finishedPolicySummary.packagePolicySummary.policy.include &&
            this.stateService.viewModel.finishedPolicySummary.packagePolicySummary.generalLiabilityLineOfBusiness) {
            this.generalLiabilityPremium = this.stateService.viewModel.finishedPolicySummary.packagePolicySummary.generalLiabilityLineOfBusiness.writtenPremium;
            this.totalPremium += this.generalLiabilityPremium;
        }
        if (this.stateService.viewModel.finishedPolicySummary.packagePolicySummary &&
            this.stateService.viewModel.finishedPolicySummary.packagePolicySummary.policy.include &&
            this.stateService.viewModel.finishedPolicySummary.packagePolicySummary.commercialAutoLineOfBusiness) {
            this.commercialAutoPremium = this.stateService.viewModel.finishedPolicySummary.packagePolicySummary.commercialAutoLineOfBusiness.writtenPremium;
            this.totalPremium += this.commercialAutoPremium;
        }
        if (this.stateService.viewModel.finishedPolicySummary.deliveryAutoPolicySummary &&
            this.stateService.viewModel.finishedPolicySummary.deliveryAutoPolicySummary.policy.include) {
            this.deliveryAutoPremium = this.stateService.viewModel.finishedPolicySummary.deliveryAutoPolicySummary.policy.writtenPremium;
            this.totalPremium += this.deliveryAutoPremium;
        }
        if (this.stateService.viewModel.finishedPolicySummary.workersCompPolicySummary &&
            this.stateService.viewModel.finishedPolicySummary.workersCompPolicySummary.policy.include) {
            this.workersCompPremium = this.stateService.viewModel.finishedPolicySummary.workersCompPolicySummary.policy.writtenPremium;
            this.totalPremium += this.workersCompPremium;
        }
        if (this.stateService.viewModel.finishedPolicySummary.packagePolicySummary &&
            this.stateService.viewModel.finishedPolicySummary.packagePolicySummary.policy.include &&
            this.stateService.viewModel.finishedPolicySummary.packagePolicySummary.umbrellaLineOfBusiness) {
            this.umbrellaPremium = this.stateService.viewModel.finishedPolicySummary.packagePolicySummary.umbrellaLineOfBusiness.writtenPremium;
            this.totalPremium += this.umbrellaPremium;
        }

        this.screenLockService.broadcast(0);

    }

    public goNext(): void {
        this.navigationService.goNext();
    }
}